export default "__VITE_ASSET__CxAAepWZ__"